import { render, staticRenderFns } from "./my.vue?vue&type=template&id=b9da3fd4&"
import script from "./my.vue?vue&type=script&lang=js&"
export * from "./my.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports